module.exports = __webpack_public_path__ + "img/applied_eco.4c197c60.png";